// extracted by mini-css-extract-plugin
module.exports = {"list":"DownloadsList_list__20Q-m","noReports":"DownloadsList_noReports__Vuirt"};